// extracted by mini-css-extract-plugin
module.exports = {"heading":"UQ0qN-lqm3eaO74L5ez3X","row":"_3UpanOGHF5_kEuZsOcJRjc","flex1":"_3n9wSRt5lp4TI3lvyF3tlp"};